import { defineMessages } from 'react-intl';

const messages = defineMessages({
  noResults: {
    id: 'search-results.noneFound',
    defaultMessage: 'No results found.',
  },
  tryAgain: {
    id: 'search-results.tryAgain',
    defaultMessage: 'Please try a new search.',
  },
  moreResults: {
    id: 'search-results.moreResults',
    defaultMessage: 'More Results',
  },
  chooseSchool: {
    id: 'intermediate.search-results.chooseSchool',
    defaultMessage: 'Please choose a school or refine your search.',
  },
  chooseSchoolName: {
    id: 'intermediate.search-results.chooseSchoolName',
    defaultMessage: 'Please choose a school or redo your search.',
  },
  schoolName: {
    id: 'common.schoolName',
    defaultMessage: 'School Name',
  },
  schoolLocation: {
    id: 'common.location',
    defaultMessage: 'Location',
  },
  schoolCountry: {
    id: 'common.country',
    defaultMessage: 'Country',
  },
  interested: {
    id: 'search-results.interested',
    defaultMessage: 'Interested Students',
  },
  interestedtooltip: {
    id: 'search-results.interested.tooltip',
    // eslint-disable-next-line max-len
    defaultMessage: `Interested Students displays the number of Naviance students from each high school who have your institution on their “Colleges I’m Thinking About” or “Colleges I’m Applying To” list.

    The academic year turns over on July 15, at which point graduated seniors are removed and incoming freshmen are added to the total.

    N/A indicates that a value is below ten or is unavailable. Remember to consider high school size when comparing values across schools.`,
  },
  interestedunlock: {
    id: 'search-results.interested.unlock',
    defaultMessage: 'See the number of  Naviance students interested in your institution',
  },
  showingCount: {
    id: 'search-results.showingCount',
    defaultMessage: 'Showing 1-{count, number} of {total, number}',
  },
  resultDescription: {
    id: 'search-results.description.result',
    defaultMessage: 'Results are listed alphabetically by country, state, county, city, and then name.',
  },
});

export default messages;
